import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalender5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalender5"><Path d="M15 3H9V5H7V3H3V8H21V3H17V5H15V3Z" fill="currentColor"/><Path d="M21 10H3V21H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalender5;
